module.exports = __webpack_public_path__ + "static/img_1922-44aa7071c445cb9c0a948252aa9b513f.webp";